module.exports = __webpack_public_path__ + "img/rightcalf-ectomorph-male.9f097aae.svg";